export default {
  state: {
    visibility: false,
    real_session_id: null
  },
  mutations: {
    SET_NOTIFICATION_BANNER_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    INIT_NOTIFICATION_BANNER_REAL_SESSION_ID(state, payload) {
      state.visibility = true
      state.real_session_id = payload.real_session_id
    },
    RESET_NOTIFICATION_BANNER(state) {
      state.visibility = false
      state.real_session_id = null
    }
  },
  actions: {
    checkSelectedCallInNotificationBanner({ state, commit }, real_session_id) {
      if (state.visibility && state.real_session_id === real_session_id) commit('RESET_NOTIFICATION_BANNER')
    }
  }
}
